import { render, staticRenderFns } from "./Article12.vue?vue&type=template&id=4ec47ac0&"
import script from "./Article12.vue?vue&type=script&lang=js&"
export * from "./Article12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports